import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
 
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const formatCurrency = (value: number, currency: string = "EUR") => {
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
};

// Regular moving average for absolute values (like revenue, customer count, etc.)
export function calculateMovingAverage(
  data: { date: string; value: number }[],
  windowSize: number = 6
): { date: string; value: number; ma: number }[] {
  return data.map((item, index) => {
    const startIndex = Math.max(0, index - windowSize + 1);
    const window = data.slice(startIndex, index + 1);
    const sum = window.reduce((acc, curr) => acc + curr.value, 0);
    const ma = window.length > 0 ? sum / window.length : item.value;

    return {
      ...item,
      ma,
    };
  });
}

// Moving average for rates (like churn rate) that need to be calculated from underlying values
export function calculateRateMovingAverage(
  data: { 
    date: string; 
    numerator: number;  // e.g., number of churned customers
    denominator: number;  // e.g., total customers
  }[],
  windowSize: number = 6
): { date: string; value: number; ma: number }[] {
  return data.map((item, index) => {
    // Calculate the point-in-time rate
    const value = item.denominator > 0 ? (item.numerator / item.denominator) : 0;

    // Calculate the moving average rate using sums of underlying values
    const startIndex = Math.max(0, index - windowSize + 1);
    const window = data.slice(startIndex, index + 1);
    
    const totalNumerator = window.reduce((acc, curr) => acc + curr.numerator, 0);
    const totalDenominator = window.reduce((acc, curr) => acc + curr.denominator, 0);
    
    const ma = totalDenominator > 0 ? (totalNumerator / totalDenominator) : 0;

    return {
      date: item.date,
      value,
      ma,
    };
  });
}